import { EnvType } from "./envType";
import { ServiceApi } from "./serviceApi";
import { ServiceInternetAcquiring } from "./serviceInternetAcquiring";
import { ServiceOrdering } from "./serviceOrdering";

export class ConfigSite { 
  /** Режим среды выполнения */
  Mode: EnvType;

  /** Название сайта */
  WebSitesName: string;

  /** Сервис для работы с заказами */
  ServiceOrdering: ServiceOrdering;

  /** Сервис для работы с интернет-эквайрингами */
  ServiceInternetAcquiring: ServiceInternetAcquiring;

  /** Сервис для работы с Апи ИМ */
  ServiceApi: ServiceApi;

  constructor(env: EnvType) {
    this.Mode = env;
    this.WebSitesName = 'sa';

    switch (env) {
      case EnvType.LOCAL:
        this.ServiceOrdering = new ServiceOrdering("http://master-ordering-eshop.dev.eshop.aservices.tech");
        this.ServiceInternetAcquiring = new ServiceInternetAcquiring("http://master-internetacquiring-eshop.dev.eshop.aservices.tech");
        this.ServiceApi = new ServiceApi("https://action-press.ru");
        
        break;
      case EnvType.DEVELOPMENT:
        this.ServiceOrdering = new ServiceOrdering("http://master-ordering-eshop.dev.eshop.aservices.tech");
        this.ServiceInternetAcquiring = new ServiceInternetAcquiring("http://master-internetacquiring-eshop.dev.eshop.aservices.tech");
        this.ServiceApi = new ServiceApi("https://action-press.ru");
        
        break;
      case EnvType.RELEASE_CANDIDATE:
        this.ServiceOrdering = new ServiceOrdering("https://release-ordering-eshop.rc.eshop.aservices.tech");
        this.ServiceInternetAcquiring = new ServiceInternetAcquiring("https://release-internetacquiring-eshop.rc.eshop.aservices.tech");
        this.ServiceApi = new ServiceApi("https://release-action-press-ru.rc.eshop.aservices.tech");
        
        break;
      case EnvType.PRODUCTION:
        this.ServiceOrdering = new ServiceOrdering("https://ordering.action-press.ru");
        this.ServiceInternetAcquiring = new ServiceInternetAcquiring("https://ia.action-press.ru");  
        this.ServiceApi = new ServiceApi("https://action-press.ru");
      
        break;
      case EnvType.STABLE:
        this.ServiceOrdering = new ServiceOrdering("https://stable-ordering-eshop.rc.eshop.aservices.tech");
        this.ServiceInternetAcquiring = new ServiceInternetAcquiring("https://stable-internetacquiring-eshop.rc.eshop.aservices.tech");
        this.ServiceApi = new ServiceApi("https://stable-api-eshop.rc.eshop.aservices.tech");
        
        break;
      default:
        this.ServiceOrdering = new ServiceOrdering("http://master-ordering-eshop.dev.eshop.aservices.tech");
        this.ServiceInternetAcquiring = new ServiceInternetAcquiring("http://master-internetacquiring-eshop.dev.eshop.aservices.tech");
        this.ServiceApi = new ServiceApi("https://action-press.ru");
        
        break;
    }
  }
}
